module.exports = __webpack_public_path__ + "static/img/guide-18.fecd8d1a.png";